import { getIcon } from "../../../../../../../utils/get-icon";
import { ContentWrapper, Icon, InnerWrapper, Text, Title } from "./styled";

const Index = () => {
  return (
    <ContentWrapper>
      <InnerWrapper>
        <Icon>{getIcon("cursor")}</Icon>
        <Title>Velg et element</Title>
        <Text>
          Trykk på et element fra tidslinjen eller i videospilleren for å gjøre
          endringer.
        </Text>
      </InnerWrapper>
    </ContentWrapper>
  );
};

export default Index;
